module.exports = __webpack_public_path__ + "img/bar-4.6dffadae.png";